const TemperatureResult = ({result, convertTo}) => {
    
    return (
        <h3>{result} {convertTo}</h3>
    );
};

export default TemperatureResult;